import React from 'react';
import SectionHeader from './SectionHeader';
import RYGRadio from './RYGRadio';
import NotesInput from './NotesInput';

const OPTIONS = [
  { value: 'red', label: 'I feel my investments are being neglected by myself or others' },
  { value: 'yellow', label: "I know it's important and I should be doing more" },
  { value: 'green', label: 'I am either regularly reviewing my investments, or I have a focused, diligent team that is taking great care of my investments' },
];

/**
 * Section 6 — Investment Care.
 */
export default function StepInvestmentCare({ data, onChange }) {
  return (
    <div>
      <SectionHeader
        number={6}
        title="Are your assets and investments getting the respect and care they deserve?"
        showAnnualNote={false}
      />
      <div className="cashflow-section-card">
        <RYGRadio
          id="investment_care"
          options={OPTIONS}
          value={data?.answer}
          onChange={(val) => onChange({ ...(data || {}), answer: val })}
        />
      </div>

      <NotesInput
        value={data?.notes}
        onChange={(val) => onChange({ ...(data || {}), notes: val })}
      />
    </div>
  );
}
